/**
 * SearchBar Core Utilities - Simplified version for immediate use
 */

export const SearchBarHelpers = {
  shouldShowDropdown: (
    isOpen: boolean,
    suggestionsLength: number,
    isLoading: boolean,
    error: string | null,
    query: string,
    resultsLength: number
  ): boolean => {
    return isOpen && (
      suggestionsLength > 0 ||
      isLoading ||
      (error !== null) ||
      (query.trim() !== '' && resultsLength === 0)
    );
  },

  generateComponentId: (): string => {
    return `searchbar-${Math.random().toString(36).substr(2, 9)}`;
  },

  scrollIntoViewSmooth: (element: HTMLElement) => {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest'
    });
  },

  scrollSelectedIntoView: (
    selectedIndex: number,
    listRef: React.RefObject<HTMLUListElement>
  ) => {
    if (selectedIndex >= 0 && listRef.current) {
      const selectedElement = listRef.current.children[selectedIndex] as HTMLElement;
      if (selectedElement) {
        SearchBarHelpers.scrollIntoViewSmooth(selectedElement);
      }
    }
  },

  getDisplayConfig: (state: {
    isOpen: boolean;
    suggestions: unknown[];
    isLoading: boolean;
    error: string | null;
    query: string;
    results: unknown[];
  }) => {
    const componentId = SearchBarHelpers.generateComponentId();
    
    return {
      showDropdown: SearchBarHelpers.shouldShowDropdown(
        state.isOpen,
        state.suggestions.length,
        state.isLoading,
        state.error,
        state.query,
        state.results.length
      ),
      componentId,
      dropdownId: `${componentId}-dropdown`,
      inputId: `${componentId}-input`
    };
  }
};